module.exports = __webpack_public_path__ + "static/img/left_dis.bfd376f0.png";